import styled from "styled-components";

export const ColumnWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);
`;

export const RowWrapper = styled.div`
    display: flex;
    gap: var(--spacing-16);
`;
